import ReactGA from "react-ga4";

// Substitua pelo seu ID do Google Analytics
const GA_MEASUREMENT_ID = "G-9QPW6C7XFS"; 

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
